import { CHAINS } from "../api/utils";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function RoundCardStat(props) {
  var _CHAINS$props$chainId;
  const matchAmount = BigInt(props.matchAmount);
  const matchAmountNormalized = matchAmount / 1000000000000000000n;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex justify-between mb-4",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex text-xs my-auto",
      children: [/*#__PURE__*/_jsxs("span", {
        "data-testid": "approved-applications-count",
        children: [props.approvedApplicationsCount, " projects"]
      }), /*#__PURE__*/_jsx("span", {
        className: "mx-1",
        children: "|"
      }), /*#__PURE__*/_jsx("span", {
        className: "mr-1",
        "data-testid": "match-amount",
        children: matchAmountNormalized.toLocaleString()
      }), /*#__PURE__*/_jsxs("span", {
        "data-testid": "match-token",
        children: [props.token, " match amount"]
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("img", {
        className: "w-8",
        src: (_CHAINS$props$chainId = CHAINS[props.chainId]) === null || _CHAINS$props$chainId === void 0 ? void 0 : _CHAINS$props$chainId.logo,
        alt: "Round Chain Logo"
      })
    })]
  });
}
export default RoundCardStat;